<template>
  <section>
    <div class="max-w-6xl mx-auto px-4 sm:px-6">
      <div class="py-12 md:py-20 border-t border-gray-200 lg:border-0 lg:pt-0">
        <!-- Section header -->
        <div class="max-w-3xl mx-auto text-center pb-12">
          <h2 class="h2">よくある質問</h2>
        </div>

        <!-- Faqs -->
        <ul class="grid gap-8 md:grid-cols-2 xl:col-gap-16 lg:row-gap-12">
          <li>
            <h4 class="text-xl font-medium mb-2 question">どのような人が参加していますか？</h4>
            <p class="text-lg text-gray-600 answer">
              幅広い世代の方が参加していますが、他の世代に比べると40代〜60代女性が比較的多く参加しています。参加目的はどの世代も様々ですが、身体の悩みを解決したい方から健康のことを学ぶ学校のような場所としても参加しています
            </p>
          </li>

          <li>
            <h4 class="text-xl font-medium mb-2 question">運動が苦手で面倒くさがりやですができますか？</h4>
            <p class="text-lg text-gray-600 answer">
              私服でもできるくらい楽な動きや簡単な動きも多く、日常生活で取り入れやすい運動やストレッチ内容になっています。
            </p>
          </li>
          <li>
            <h4 class="text-xl font-medium mb-2 question">受講環境について教えて下さい。</h4>
            <p class="text-lg text-gray-600 answer">
              Zoomを使用できる環境（スマートフォン、タブレット、パソコン）から受講が可能です。
              《Zoomのご利用が不安な方は事前動作確認が可能です》<br />
              以下のテストページをご利用ください。<br />
              Zoomミーティングテスト <a class="text-theme-100" href="https://zoom.us/test">https://zoom.us/test</a>
            </p>
          </li>
          <li>
            <h4 class="text-xl font-medium mb-2 question">ビデオオンでないと参加できませんか？</h4>
            <p class="text-lg text-gray-600 answer">
              必ずではありませんのでご安心ください。できる限りカメラをオンにしていただけるとトレーナーが進行しやすいのと、参加者の動きの確認ができるのでオススメしています。
            </p>
          </li>
          <li>
            <h4 class="text-xl font-medium mb-2 question">途中入退室は可能ですか？</h4>
            <p class="text-lg text-gray-600 answer">
              はい、可能です。予定が変わった際でも参加できる時間だけぜひご参加下さい。
            </p>
          </li>
          <li>
            <h4 class="text-xl font-medium mb-2 question">支払い方法を教えて下さい。</h4>
            <p class="text-lg text-gray-600 answer">
              下記のお問い合わせからお申し込み頂いたのち、Paypalのリンクから決済をお願いいたします。２ヶ月目以降は、毎月自動で課金されます。
            </p>
          </li>
          <li>
            <h4 class="text-xl font-medium mb-2 question">月額料金はいつ支払うのですか？</h4>
            <p class="text-lg text-gray-600 answer">
              初回登録時に、１回目のお支払い手続きをしていただき、それ以降は1ヶ月おきに定期的に引き落としになります。
            </p>
          </li>
          <li>
            <h4 class="text-xl font-medium mb-2 question">クレジットカード以外の決済方法は選べますか？</h4>
            <p class="text-lg text-gray-600 answer">
              基本的にはクレジットカード決済のみとなっております。クレジットカードがない場合は個別にご対応させて頂きます。お気軽にお問い合わせください。
            </p>
          </li>
          <li>
            <h4 class="text-xl font-medium mb-2 question">スペースはどのくらい必要ですか？</h4>
            <p class="text-lg text-gray-600 answer">
              レッスンのプログラムによって若干異なりますが、半径１m程あれば十分に参加可能です。１人暮らしのワンルーム契約の方でも、スペースを作りレッスン受講することは可能です。
            </p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Faqs",
}
</script>

<style lang="scss" scoped>
.question {
  // position: relative;

  &::before {
    content: "Q.";
    color: rgba(#3ca8f6, 0.6);
    // position: absolute;
    // left: -11px;
    font-size: 2em;
    // top: -57px;
    font-weight: 700;
  }
}

.answer {
  position: relative;

  &::before {
    content: "A.";
    color: rgba(#06efb1, 0.6);
    // position: absolute;
    // left: -6px;
    font-size: 2em;
    // top: -31px;
    font-weight: 700;
  }
}
</style>
